import {DateTimeFormatter, LocalDate} from '@js-joda/core';
import {IconButton, makeStyles} from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import LockIcon from '@material-ui/icons/Lock';
import React, {useMemo} from 'react';
import {useCapacityContext} from "../Utils/CapacityContextProvider";
import {Holiday} from "../Utils/EmployeeSchedulesCompiler";

type Props = {
    employeeId : number;
    startDate : LocalDate;
    currentWeek : string;
};


const useStyles = makeStyles(theme => ({
    currentWeek: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
    },
    input: {
        color: 'inherit',
        border: 'none',
        backgroundColor: 'transparent',
        margin: 0,
        padding: 0,
        width: 30,
        textAlign: 'right',
    },
}));

const findNumberOfCompanyHolidays = (holidays : Holiday[], checkDate : LocalDate) => {
    const foundHolidays = holidays?.filter(holiday => {
        const holidayDate = LocalDate.parse(holiday.HolidayDate, DateTimeFormatter.ofPattern('M/d/yyyy'));
        return holidayDate.isAfter(checkDate) && holidayDate.isBefore(checkDate.plusDays(7))
    })

    return foundHolidays.length;
}

const HolidayRow : React.FC<Props> = ({employeeId, startDate, currentWeek} : Props) => {
    const {holidays} = useCapacityContext();
    const classes = useStyles();

    const holidayHours = useMemo(() => {
        return new Array(8)
            .fill(0)
            .map((value, index) => {
                const date = startDate.plusDays(index * 7);
                return {
                    hours: holidays ? findNumberOfCompanyHolidays(holidays, date) * 8 : 0,
                    isCurrentWeek: date.toString() === currentWeek
                };
            });
    }, [holidays, startDate, currentWeek])

    return <>
        {holidays && <TableRow>
            <TableCell>
                <IconButton size="small" edge="start">
                    <LockIcon fontSize="small"/>
                </IconButton>
                Company Time Off
            </TableCell>

            {holidayHours.map(({hours, isCurrentWeek}, index) => {
                return <TableCell
                    key={`holiday-row-${employeeId}-${index}`}
                    className={isCurrentWeek ? classes.currentWeek : undefined}>
                    <input type="text" disabled={true} maxLength={2} className={classes.input} value={hours}/>
                </TableCell>
            })}
        </TableRow>}
    </>;
};

export default HolidayRow;
